import { CanDeactivateFn } from '@angular/router';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanDeactivate,
} from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmInvoiceDeleteComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';

export const canDeactivateGuard: CanDeactivateFn<unknown> = (
  component,
  currentRoute,
  currentState,
  nextState,
) => {
  return true;
};

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(private dialog: MatDialog) {}

  canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Check if component has canDeactivate method
    if (component.canDeactivate) {
      const result = component.canDeactivate();

      // If it's a boolean, return it
      if (typeof result === 'boolean') {
        if (result) return true;
        return this.openConfirmDialog();
      }

      // If it's a Promise or Observable
      return new Promise<boolean>((resolve) => {
        if (result instanceof Observable) {
          result.subscribe((canDeactivate) => {
            if (canDeactivate) {
              resolve(true);
            } else {
              this.openConfirmDialog().then((dialogResult) => {
                resolve(dialogResult);
              });
            }
          });
        } else if (result instanceof Promise) {
          result.then((canDeactivate) => {
            if (canDeactivate) {
              resolve(true);
            } else {
              this.openConfirmDialog().then((dialogResult) => {
                resolve(dialogResult);
              });
            }
          });
        }
      });
    }

    return true;
  }

  async openConfirmDialog(): Promise<boolean> {
    const dialogRef = this.dialog.open(ConfirmInvoiceDeleteComponent, {
      width: '420px',
      /* Niente altezza fissa: con la barra azioni panna a filo bordo il
         contenuto detta l'altezza, altrimenti resta uno spazio vuoto sopra
         la barra. Lo stile e' in styles.scss (.izy-confirm-dialog-panel):
         il dialog vive nell'overlay CDK, fuori dai componenti. */
      panelClass: 'izy-confirm-dialog-panel',
      data: {
        /* Veste d'allarme: uscire scarta il documento, e il lavoro fatto non
           torna indietro. E' l'unico caso non-eliminazione che la porta. Il
           dialog si mette da se' la panelClass .izy-danger-dialog-panel. */
        danger: true,
        title: 'Modifiche non salvate',
        message: 'Ci sono modifiche non salvate. Vuoi davvero uscire?',
        checkboxLabel: 'Confermo di voler scartare il documento e accetto',
      },
    });

    const result = await dialogRef.afterClosed().toPromise();

    // Convert undefined/falsy to boolean
    return !!result;
  }
}
